<template>
  <div v-if="this.insurance.length > 0 && this.reportData.length > 0">
    <v-card elevation="2">
      <v-row justify="space-between">
        <v-col cols="6" class="py-0">
          <v-card-title primary-title>MRA</v-card-title>
        </v-col>
      </v-row>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :headers="headers"
        :items="reportData"
        :search="search"
        :sort-desc="[true]"
        :footer-props="{
          'items-per-page-options': [10, 20, -1]
        }"
        :items-per-page="10"
        @update:pagination="getMore()"
        multi-sort
        class="elevation-0 col-md-12 m-auto"
      >
        <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item }">
          <div v-if="header.text === 'Name'">{{ item[header.text] }}</div>
          <v-chip v-else dark :color="getColor(item[header.text])">
            {{ item[header.text] }}
          </v-chip>
        </template>

        <template v-slot:body.append="props">
          <tr v-if="load === false">
            <td v-for="header in headers">
              <div v-if="header.text === 'Name'">Summary Average:</div>
              <v-chip v-else dark :color="getColor(getAverageCol(props.items, header.text))">
                {{ getAverageCol(props.items, header.text) }}
              </v-chip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'mra',
  props: [
    'organization',
    'group',
    'providers',
    'locations',
    'insurance',
    'startDate',
    'endDate',
    'currentTab',
    'data'
  ],
  data() {
    return {
      search: '',
      load: true,
      sortDesc: false,
      headers: [],
      itemsPerPage: 12,
      itemsPerPageArray: [3, 6, 12],
      page: 1,
      pagination: '',
      sortBy: 'Count',
      keys: ['month', 'mra'],
      reportData: [],
      filteredItems: [],
      cancelSource: null,
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.reportData.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter(key => key !== 'reportData');
    },
  },
  methods: {
    getHeaders() {
      this.headers = [];
      const temp = [];

      // get unique values for keys
      for (let i = 0; i < this.reportData.length; i++) {
        Object.keys(this.reportData[i]).forEach((key) => {
          if (temp.indexOf(key) === -1) {
            temp.push(key);
          }
        });
      }

      // reorder array with name first and average last
      const sortedTemp = temp.sort();
      sortedTemp.unshift(sortedTemp.pop());

      // use unique values to push in headers
      sortedTemp.forEach((key) => {
        this.headers.push({ text: key, value: key });
      });
    },
    getAverageCol(items, header) {
      let total = 0;
      let counter = 0;

      items.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (key === header) {
            total += item[header];
            counter += 1;
          }
        });
      });
      return (total / counter).toFixed(2);
    },
    getColor(mra) {
      if (mra > 1) return 'green lighten-1';
      return 'red lighten-1';
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
  },
  watch: {
    data() {
      this.reportData = this.data;
      this.getHeaders();
    }
  },
};
</script>
